import { lazy, useEffect } from 'react';
import type {
  UpgradeOpenInput,
  UpgradeOpenOverrides,
} from '../lib/upgrade-routing';
import { buildUpgradeDialogProps } from '../lib/upgrade-routing';
import { useDialog } from './DialogProvider';

const UpgradeContent = lazy(async () => {
  const module = await import('../components/upgrade/UpgradeContent.web');
  return { default: module.UpgradeContent };
});

export const useUpgradeModal = () => {
  const { open } = useDialog();

  return {
    open: (input?: UpgradeOpenInput, overrides?: UpgradeOpenOverrides) =>
      open('upgrade', buildUpgradeDialogProps(input, overrides)),
  };
};

/** Registers the upgrade dialog once: wrap inside DialogProvider. */
export function UpgradeModalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { register } = useDialog();

  useEffect(() => {
    register('upgrade', UpgradeContent);
  }, [register]);

  return <>{children}</>;
}
